import { getApiClient } from '../../api/client';

export async function getTask(uuid: string) {
  const client = getApiClient();
  const { data, error } = await client.GET('/tasks/{uuid}', {
    params: { path: { uuid } },
  });
  if (error) throw new Error(`Failed to fetch task: ${JSON.stringify(error)}`);
  return data;
}
